export const isRegex = (str: string) => {
  try {
    const regexPattern = /^.*[\\^$.*+?()[\]{}|].*$/;
    if (regexPattern.test(str)) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

/**
 * 検索文字列を空白文字で分割する
 * @param query
 * @returns string[]
 */
export const splitQuery = (query: string) => {
  const splitQuery = query
    // eslint-disable-next-line no-irregular-whitespace
    .split(/(\s|　)/)
    .map((query) => query.trim())
    .filter(Boolean);
  return splitQuery.length ? splitQuery : [query];
};

/**
 * 検索文字配列からAND検索用の正規表現を生成する
 * @param queries
 * @returns string
 */
export const createAndSearchRegex = (queries: string[]) => {
  let regexQuery = "^";
  queries.forEach((word) => {
    regexQuery += `(?=.*${word})`;
  });
  regexQuery += ".*$";
  return regexQuery;
};

/**
 * 検索文字列からOR検索用の正規表現を生成する
 * @param queries
 * @returns string
 */
export const createOrSearchRegex = (queries: string[]) => {
  let regexQuery = "(";
  queries.forEach((word, index) => {
    regexQuery += `${word}`;
    if (index !== queries.length - 1) {
      regexQuery += "|";
    }
  });
  regexQuery += ")";
  return regexQuery;
};
